// @flow
export type PriceObj = {
  amount: string,
  currencyIso: string,
};

export type BookingAddOn = {
  name: string,
  slug: string,
  pricePerUnit: string,
  pricePerUnitObj: PriceObj,
  totalPrice: string,
  active: boolean,
  frequency: string,
  unit: string,
  unitLabel: string,
  unitAsSentence: string,
  numUnits?: number,
  isAlternativeRate: boolean,
  isEditable: boolean,
  isFutureService: boolean,
  pet?: string,
};

export const PriceObjDefaults: PriceObj = {
  amount: '',
  currencyIso: 'USD',
};

export const BookingAddOnDefaults = {
  name: '',
  slug: '',
  pricePerUnit: '',
  pricePerUnitObj: PriceObjDefaults,
  totalPrice: '',
  active: false,
  frequency: '',
  unit: '',
  unitLabel: '',
  unitAsSentence: '',
  numUnits: 0,
  isAlternativeRate: false,
  isEditable: false,
  isFutureService: false,
  pet: '',
};



// WEBPACK FOOTER //
// ../react-lib/src/types/BookingAddOn.js